import { getCSRFToken, fetchCSRFToken } from "./csrf";
import Swal from "sweetalert2";

export async function logOut() {
  try {
    let csrfToken = getCSRFToken();
    if (!csrfToken) {
      await fetchCSRFToken();
      csrfToken = getCSRFToken();
    }

    const response = await fetch("/api/_allauth/browser/v1/auth/session", {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": csrfToken,
      },
      credentials: "include",
    });

    if (response.ok) {
      Swal.fire("Success", "You have successfully logged out.", "success");
      return true;
    } else if (response.status === 401) {
      Swal.fire("Success", "You have successfully logged out.", "success");
      return true;
    } else if (response.status === 403) {
      Swal.fire("Notice", "Session has already ended or is invalid.", "info");
    } else {
      Swal.fire("Error", "Failed to log out.", "error");
    }

    return false;
  } catch (error) {
    Swal.fire("Error", "An error occurred during logout.", "error");
    return false;
  }
}
